<template>
    <div class="memory__tags">
        <div v-for="(tag, index) in tags" :key="index">
            <div v-if="tag.hasOwnProperty('edited') && tag.edited" class="memory__tag">
                <el-input v-focus type="text" v-model="tags[index].name" :maxlength="tagLength.max"/>
                <button class="memory__tag-save btn" @click.prevent="finishEditing(index, tag)">
                    <svg width="16" height="11">
                        <use xlink:href="/assets/front/img/sprite.svg#icon-check-thin"></use>
                    </svg>
                </button>
            </div>
            <div v-else class="memory__tag">
                {{ '#' + tag.name }}
                <button class="memory__tag-remove btn" type="button" @click="tags.splice(index, 1)">
                    <svg width="11" height="11">
                        <use xlink:href="/assets/front/img/sprite.svg#icon-del-thin"></use>
                    </svg>
                </button>
            </div>
        </div>
        <button class="memory__tag-add btn" @click.prevent="addTag">
            <svg width="11" height="11">
                <use xlink:href="/assets/front/img/sprite.svg#icon-del-thin"></use>
            </svg>
        </button>
    </div>
</template>

<script>
import {mapGetters, mapMutations} from "vuex";

export default {
    name: "MemoriesEditTags",
    props: {
        value: {
            type: Array,
            requested: true,
            default: () => [],
        }
    },
    directives: {
        focus: {
            inserted(el) {
                const element = el.querySelector('.el-input__inner');

                element.focus();
            }
        },
    },
    data() {
        return {
            tags: this.value,
            tagLength: {
                max: 50,
                min: 1
            }
        }
    },
    computed: {
        ...mapGetters('profile', {
            profileTags: 'tags'
        })
    },
    watch: {
        value(val) {
            if (JSON.stringify(this.tags) !== JSON.stringify(val)) {
                this.$set(this, 'tags', val);
            }
        },
        tags: {
            handler(val) {
                this.$emit('input', val);
            },
            deep: true
        }
    },
    methods: {
        ...mapMutations('profile', [
            'pushTag'
        ]),
        addTag() {
            this.tags.push({
                name: '',
                edited: true
            });
        },
        validateTag(tag) {
            const tagLength = String(tag.name).length;

            if (this.tagLength.min > tagLength) {
                return false;
            }

            return this.tags.filter(item => item.name === tag.name).length <= 1;
        },
        finishEditing(indexTag, currentTag) {
            if (!this.validateTag(currentTag)) {
                this.tags.splice(indexTag, 1);

                return;
            }

            this.$set(this.tags[indexTag], 'edited', false);

            let tagInProfile = this.profileTags.filter(tag => {
                return tag.name === currentTag.name;
            });

            tagInProfile.length > 0
                ? this.$set(this.tags, indexTag, tagInProfile[0])
                : this.pushTag({name: currentTag.name});
        }
    },
    beforeDestroy() {
        this.$emit('input', this.tags.filter(
            tag => !tag.hasOwnProperty('edited') || (tag.hasOwnProperty('edited') && tag.edited === false)
        ));
    }
}
</script>
